import { useCallback, useEffect } from "react";
import { Tooltip } from "antd";
// import { VerticalAlignTopOutlined } from "@ant-design/icons";
import "./index.less";
// import consult from "@/images/zxzx.png";
// import phone from "@/images/phone.png";
import webappQR from "@/images/webappQR.png";
import servicePng from "@/images/side-service.png";
import quickOrderPng from "@/images/side-quickOrder.png";
import onlinePng from "@/images/icon-side-online.png";
import pbonePng from "@/images/icon-side-phone.png";
import webappPng from "@/images/icon-side-webapp.png";
import topPng from "@/images/icon-side-top.png";
import { backToTop } from "@/utils/dom";
import { useNavigate } from "react-router";

const SideBar = ({ fixNavShow = false }) => {
  const navigate = useNavigate();

  const back2Top = useCallback(() => {
    backToTop();
  }, []);

  useEffect(() => {
    if ((window as any).zc) {
      (window as any).zc("dynamic_ready");
    }
  }, []);

  return (
    <>
      <div className="sidebar-wrapper shop-pc">
        <ul>
          <li className="zcbtn">
            <img src={onlinePng} alt="" />
            <p>在线咨询</p>
          </li>
          <li className="phone">
            <Tooltip
              placement="left"
              overlayClassName="hover-phone"
              color="#ffffff"
              // arrow={false}
              title={
                <div>
                  <h3>电话咨询</h3>
                  <p>工作时间：24小时</p>
                  <p>热线电话：400-921-1717</p>
                </div>
              }
            >
              <img src={pbonePng} alt="" />
              <p>电话咨询</p>
            </Tooltip>
          </li>
          <li>
            <Tooltip
              // open={true}
              placement="left"
              overlayClassName="hover-webapp"
              color="#ffffff"
              title={
                <div>
                  <h3>
                    <span>微信扫码</span>
                  </h3>
                  <img src={webappQR} alt="" />
                  <p>盈德气体商城微信小程序</p>
                </div>
              }
            >
              <img src={webappPng} alt="" />
              <p>商城小程序</p>
            </Tooltip>
          </li>
          {fixNavShow ? (
            <li onClick={back2Top}>
              <img src={topPng} alt="" />
              <p>回顶部</p>
            </li>
          ) : null}
        </ul>

        {/* <div className="consult-content zcbtn">
          <img src={consult} alt="" />
          <p>在线咨询</p>
        </div>
        <div className="phone-content">
          <img src={phone} alt="" />
          <p>电话咨询</p>
          <p>400-921-1717</p>
        </div>
        <div className="webapp-content">
          <img src={webappQR} alt="" />
          <p>盈德气体商城</p>
          <p>微信小程序</p>
        </div>
        <div className="back-top" onClick={back2Top}>
          <VerticalAlignTopOutlined />
          <p>回到顶部</p>
        </div> */}
      </div>
      <div className="sidebar-m-wrapper shop-m">
        <img
          onClick={() => {
            navigate("/quickOrder/dytOrder");
          }}
          src={quickOrderPng}
          alt=""
        />
        <div className="zcbtn">
          <img src={servicePng} alt="" />
        </div>
      </div>
    </>
  );
};

export default SideBar;
